import { render, staticRenderFns } from "./ProtectedImage.vue?vue&type=template&id=1a68c6e9&scoped=true&"
import script from "./ProtectedImage.vue?vue&type=script&lang=js&"
export * from "./ProtectedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a68c6e9",
  null
  
)

export default component.exports